import { useTranslation } from "react-i18next";
import { ReportBlock } from "./ReportBlock";

const KEYS = ["opening_equity", "capital_additions", "distributions", "result", "closing_equity"];

// IAS 1 statement of changes in equity.
export const EquityBlock = ({ equity }) => {
  useTranslation();
  if (!equity) return null;

  return (
    <ReportBlock
      testId="report-equity"
      titleKey="acct.report.equityChanges"
      items={KEYS.map((key) => ({ key, value: equity[key], strong: key === "closing_equity" }))}
    />
  );
};
